// 根据当前 i18n 语言切换 AntD 组件库内置文案（ConfigProvider locale）
// 以及 dayjs 语言。msMY 若 antd 无对应包则回退 enUS。

import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import type { Locale } from 'antd/es/locale';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';
import koKR from 'antd/locale/ko_KR';
import thTH from 'antd/locale/th_TH';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/th';
import 'dayjs/locale/ms';
import 'dayjs/locale/en';

const ANTD_LOCALES: Record<string, Locale> = {
  zh: zhCN,
  en: enUS,
  ja: jaJP,
  ko: koKR,
  th: thTH,
  // msMY 在部分 antd 版本中不存在，统一回退 enUS
  ms: enUS,
};

const DAYJS_LOCALES: Record<string, string> = {
  zh: 'zh-cn',
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  ms: 'ms',
};

interface Props {
  theme?: Record<string, unknown>;
  children: React.ReactNode;
}

const AntdLocaleProvider: React.FC<Props> = ({ theme, children }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];
  const antdLocale = ANTD_LOCALES[lang] || enUS;

  useEffect(() => {
    dayjs.locale(DAYJS_LOCALES[lang] || 'en');
  }, [lang]);

  return (
    <ConfigProvider locale={antdLocale} theme={theme as any}>
      {children}
    </ConfigProvider>
  );
};

export default AntdLocaleProvider;
